module.exports = __webpack_public_path__ + "img/Icon_Fell.f6318c72.png";